import React, { Component } from 'react';
import { CssLoader, TabCard } from '@cimpress/react-components';

import './css/app.css';

import auth from './auth';
import CartoonClassification from './components/cartoonClassification';
import Crispify from './components/crispify';
import Header from './header';
import Recolorization from './components/recolorization';
import Rendering from './components/rendering';

class App extends Component {
    render() {
        return (
            <CssLoader>
                <div className='page'>
                    <Header />
                    {auth.isLoggedIn() &&
                        <div className='preview'>
                            <TabCard tabs={[
                                { name: 'Rendering UI', block: <Rendering /> },
                                { name: 'Crispify', block: <Crispify /> },
                                { name: 'Cartoon Classification', block: <CartoonClassification /> },
                                { name: 'Recolorization', block: <Recolorization /> },
                            ]}
                            />
                        </div>
                    }
                    {!auth.isLoggedIn() && 'You are currently logged out. Please refresh the page to be automatically logged in'}
                </div>
            </CssLoader>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx